import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_UPDATE_BVN } from "../../../config/api";

import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { fetchUserProfile } from "./getProfile";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";

export const updateUserBvn = createAsyncThunk(
  "userBvn/update",
  async ({ data, cb, failed }, { dispatch }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_UPDATE_BVN,
        data,
      });
      toast.success("BVN updated successfully");
      dispatch(fetchUserProfile());
      cb();
      // mixpanel.track("Success", {
      //   type: "Profile",
      //   subtype: "update-BVN",
      // });
    } catch (error) {
      const msg = proccessErrorMessage(error);
      if (
        msg ===
          "The profile data provided does not match the BVN verification data. Please review and ensure all provided information is accurate." &&
        error?.response?.data?.mismatched_fields?.length > 0
      ) {
        console.log(error);
        console.log(error?.response);
        console.log(error?.response?.data);

        toast.error(
          error?.response?.data?.mismatched_fields?.length === 1
            ? `The profile data provided does not match the BVN verification data. Please check and update your ${error?.response?.data?.mismatched_fields[0]}.`
            : `The profile data provided does not match the BVN verification data. Please check and update your ${error?.response?.data?.mismatched_fields
                ?.slice(0, error?.response?.data?.mismatched_fields?.length - 1)
                ?.join(", ")} and ${
                error?.response?.data?.mismatched_fields[
                  error?.response?.data?.mismatched_fields?.length - 1
                ]
              }.`
        );
      } else {
        toast.error(msg);
      }
      // mixpanel.track("Error", {
      //   type: "Profile",
      //   subtype: "update-BVN",
      //   message: msg,
      //   error: error?.response?.data,
      // });

      failed(msg);
    }
  }
);
